import { LoadingState } from 'stores/types';

export const initialState: LoadingState = {
  isAlgoliaLoading: false,
  isFindApiLoading: false,
  isCadenasLoaded: false,
  isGoogleGroundingLoading: false,
};
